/**
 * Debug utilities for authentication modules
 * Provides conditional logging that can be toggled for production
 */

// Enable debug logging based on environment or localStorage flag
const isDebugEnabled = (): boolean => {
  if (typeof window === 'undefined') return false;

  // Check localStorage for debug flag
  const debugFlag = localStorage.getItem('auth_debug');
  if (debugFlag === 'true') return true;

  // Check if we're in development mode
  return process.env.NODE_ENV === 'development';
};

/**
 * Create a debug logger for a specific module
 */
export function createDebugLogger(moduleName: string) {
  const enabled = isDebugEnabled();

  return {
    log: (...args: any[]) => {
      if (enabled) {
        console.log(`[${moduleName}]`, ...args);
      }
    },

    error: (...args: any[]) => {
      // Always log errors, but prefix with module name
      console.error(`[${moduleName}]`, ...args);
    },

    warn: (...args: any[]) => {
      if (enabled) {
        console.warn(`[${moduleName}]`, ...args);
      }
    },

    debug: (...args: any[]) => {
      if (enabled) {
        console.log(`[${moduleName}:DEBUG]`, ...args);
      }
    }
  };
}

/**
 * Enable debug mode programmatically
 */
export function enableAuthDebug() {
  if (typeof window !== 'undefined') {
    localStorage.setItem('auth_debug', 'true');
  }
}

/**
 * Disable debug mode programmatically
 */
export function disableAuthDebug() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('auth_debug');
  }
}
